import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import PlusPill from './plus_pill'

const ClickablePill = styled(PlusPill).attrs({ as: Link })`
    margin-left: 6px;
    border: none;
    cursor: pointer;
    line-height: inherit;
    text-decoration: none;

    &:hover {
        opacity: 0.85;
    }
`

export default () => {
    return (
        <ClickablePill to="/pricing/">Keybreak Plus</ClickablePill>
    )
}
